'use strict';

var ImageQueueMixin = require('./ImageQueueMixin'),
    SizeMonitorMixin = require('./SizeMonitorMixin');

/**
 * Manages state of a sequential image queue.
 * Uses element's own `offsetWidth` and `offsetHeight` to determine requested size.
 *
 * To avoid generating too many images, we round up
 * height and width to the closest value divisible by passed `sizeStep`.
 *
 * Use `ResponsiveImageQueueMixin` instead if you need to only
 * allow several @media-* steps, or use plain `ImageQueueMixin`
 * if you need finer control over requested width.
 */
function createFlexibleImageQueueMixin(sizeStep) {
  if (!sizeStep) {
    throw new Error('Provide a minimal size delta. Use 1 for precise size, something larger to avoid too many versoins.');
  }

  return {
    mixins: [ImageQueueMixin, SizeMonitorMixin],

    componentDidUpdate: function (prevProps, prevState) {
      if (prevState.offsetWidth !== this.state.offsetWidth ||
          prevState.offsetHeight !== this.state.offsetHeight) {

        this.updateImageQueue();
      }
    },

    getNormalImageSize: function () {
      var { offsetWidth, offsetHeight } = this.state;
      if (!offsetWidth || !offsetHeight) {
        return;
      }

      return {
        width: sizeStep * Math.ceil(offsetWidth / sizeStep),
        height: sizeStep * Math.ceil(offsetHeight / sizeStep)
      };
    }
  };
}

module.exports = createFlexibleImageQueueMixin;


/** WEBPACK FOOTER **
 ** ./mixins/createFlexibleImageQueueMixin.js
 **/